<div class="fragrance-container">
  <app-button
    icon="keyboard_backspace"
    type="tertiary"
    iconPosition="left"
    size="medium"
    [text]="'home'"
    routerLink="'/'">
  </app-button>
  <builder-content
    [model]="EDITO_PAGE_MODEL"
    [content]="content"
    [apiKey]="apiKey"
    [customComponents]="customComponents"
  />
</div>
